import { render, staticRenderFns } from "./BackgroundVideo.vue?vue&type=template&id=b0197384&scoped=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=ts"
export * from "./BackgroundVideo.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundVideo.vue?vue&type=style&index=0&id=b0197384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0197384",
  null
  
)

export default component.exports